export const status = {
  opened: false,
  closed: true,
};
export const status_ru = {
  opened: 'Открытый',
  closed: 'Закрытый',
};

export const status_ru_current = {
  opened: 'Текущий',
  closed: 'Текущий',
};
export const status_full_m = {
  opened: { key: status.opened, label: status_ru.opened, bg: 'success' },

  closed: { key: status.closed, label: status_ru.closed, bg: 'secondary' },

};

export const status_full_m_current = {
  opened: { key: status.opened, label: status_ru_current.opened, bg: 'success' },

  closed: { key: status.closed, label: status_ru_current.closed, bg: 'secondary' },

};
